/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Booking
 *
 * 2 = Started
 *
 * 3 = Completed
 *
 * 4 = Canceled
 */
export enum TestDriveStatus {
  Booking = 1,
  Started = 2,
  Completed = 3,
  Canceled = 4,
}
